<template>
  <div class="main" id="app">
    <div style="display: block; margin-top: -150px">
      <img src="@/assets/img/registerTextIcon.png" class="registerTextIconCss" />
    </div>
    <div>
      <img src="@/assets/img/treeIcon.png" class="treeIconCss" />
    </div>
    <div style="display: block; margin-top: -50px">
      <img src="@/assets/img/leafIcon.png" class="leafIconCss" />
    </div>
    <div class="content" v-if="friendName !== '' && status === false">
      <img src="@/assets/img/childIcon.png" class="childIconCss" />
      <p class="topTitleCss">
        {{ friendName }}邀请你{{
          identityType * 1 === 1 ? "加入亲友团" : "成为他的好友"
        }}
      </p>
      <div class="phoneDivInputCss">
        <input type="text" placeholder="请输入您的手机号码" maxlength="11" class="phoneInputCss" v-model="phoneNumber" />
      </div>
      <div class="codeDivInputCss">
        <input type="text" placeholder="请输入验证码" maxlength="6" class="codeInputCss" v-model="codeNumber" />
        <button class="codeBtnCss" v-if="codeShow" @click="showCodeYz">
          {{ codeText }}
        </button>
        <button class="codeBtnCss" v-else>{{ codeNumcount }} s</button>
      </div>
      <div class="submitDivBtnCss">
        <button type="submit" class="submitBtnCss" @click="getRegisterSubmit">
          {{ identityType * 1 === 1 ? "加入亲友团" : "成为他的好友" }}
        </button>
      </div>
    </div>
    <div class="content" v-if="status">
      <img src="@/assets/img/childIcon.png" class="childIconCss" />
      <p class="topTitleCss">
        您已成功{{
          identityType * 1 === 1 ? "加入" : "成为"
        }}{{ friendName }}{{
          identityType * 1 === 1 ? "的亲友团" : "的好友"
        }}
      </p>
      <div class="submitDivBtnCss">
        <a :href="urlScheme" class="aLabel">打开小程序</a>
        <a href="https://h5.growth.bedoke.com/download.html" class="aLabel" style="margin-top: 30px;">下载APP</a>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Toast
  } from "vant";
  import {
    codeData,
    registerSubmit,
  } from "@/api/relativesAndFriendsRegister/index";
  import {
    scheme
  } from '@/api/scheme/index'
  export default {
    name: "relativesAndFriendsRegister",
    data() {
      return {
        phoneNumber: "",
        codeNumber: "",
        codeText: "获取验证码",
        codeShow: true,
        codeNumcount: "",
        timer: null,
        identityType: 1, //1 亲友 2好友 默认好友
        friendName: "",
        bachCode: "",
        userId: "",
        urlScheme: '', // 跳转微信小程序
        status: false
      };
    },
    created() {
      this.getDataCheck();
      this.getScheme()
    },
    methods: {
      // 获取URL Scheme 链接
      async getScheme() {
        const res = await scheme({
          redirectUrl: 'pages/tabBar/home/index'
        })
        if (res.errcode === 0) {
          this.urlScheme = res.openlink
        } else {
          this.urlScheme = 'https://h5.growth.bedoke.com/download.html'
        }
      },
      /* 数据获取校验 */
      getDataCheck() {
        let returnData = this.GetRequest();
        this.identityType = returnData.identity || 1;
        this.friendName = returnData.userName || "";
        this.bachCode = returnData.invitationCode || "";
        this.userId = returnData.userId || "";
        if (
          returnData.identity === undefined ||
          returnData.userName === undefined ||
          returnData.invitationCode === undefined ||
          returnData.userId === undefined
        ) {
          alert("数据错误！");
          window.location.replace("https://h5.growth.bedoke.com/download.html");
          return;
        }
      },
      /* 获取url地址参数 */
      GetRequest() {
        let urlStr = window.location.href;
        var url = "?" + urlStr.split("?")[1];
        var theRequest = new Object();
        if (url.indexOf("?") !== -1) {
          var str = url.substring(1);
          let strs = str.split("&");
          for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURI(
              strs[i].slice(strs[i].split("=")[0].length + 1)
            );
          }
        }
        return theRequest;
      },
      /* 验证手机号码并发送验证码 */
      showCodeYz() {
        var re = /^1[3465789]\d{9}$/; //正则判断手机号格式是否正确
        if (re.test(this.phoneNumber)) {
          if (!this.timer) {
            this.codeShow = false;
            this.getCodeData();
          }
        } else {
          Toast("请输入正确的手机号");
        }
      },
      /* 请求发送获取验证码 */
      async getCodeData() {
        const res = await codeData({
          mobile: this.phoneNumber,
          type: 1,
        });
        if (res.code === 200) {
          const TIME_COUNT = 60;
          this.codeNumcount = TIME_COUNT;
          this.timer = setInterval(() => {
            if (this.codeNumcount > 0 && this.codeNumcount <= TIME_COUNT) {
              this.codeNumcount--;
            } else {
              this.codeShow = true;
              this.codeText = "重新获取";
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
          Toast(res.msg);
        } else {
          this.codeShow = true;
          Toast(res.msg);
        }
      },
      /* 点击注册提交 */
      async getRegisterSubmit() {
        if (this.phoneNumber === "") {
          return Toast("请输入手机号码");
        }
        if (this.codeNumber === "") {
          return Toast("请输入验证码");
        }
        var re = /^1[3465789]\d{9}$/; //正则判断手机号格式是否正确
        if (re.test(this.phoneNumber)) {
          let parameter = {
            identity: this.identityType,
            mobile: this.phoneNumber,
            bachCode: this.bachCode,
            userId: this.userId,
            checkCode: this.codeNumber,
          };
          const res = await registerSubmit(parameter);
          console.log(res);
          if (res.code === 200) {
            alert(res.msg);
            this.status = true
          } else {
            if (res.msg === "您已加入亲友团") {
              alert(res.msg);
              this.status = true
            } else {
              this.status = false
              Toast(res.msg);
            }
          }
        } else {
          Toast("请输入正确的手机号");
        }
      },
    },
    components: {},
  };
</script>

<style lang="less" scope>
  #app {
    margin: 0;
    padding: 0;
    width: 100%;
    background: url("../../assets/img/relativesAndFriends.png") no-repeat top center fixed;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    height: 100%;
    position: fixed;
  }

  a {
    color: #ffffff;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-user-select: none;
  }

  .main {
    width: 100%;
    margin: 0 auto;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: center;
  }

  .registerTextIconCss {
    width: 303px;
    height: 115px;
  }

  .treeIconCss {
    width: 300px;
    height: 260px;
  }

  .leafIconCss {
    width: 390px;
    height: 130px;
  }

  .content {
    position: absolute;
    top: 60%;
    width: 90%;
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: #fff;
    border-radius: 10px;
    border-width: 20px;
    border-color: #ffa63d;
    margin-bottom: 30px;
  }

  .childIconCss {
    width: 50px;
    height: 80;
    position: absolute;
    top: -82px;
    left: 90px;
  }

  .topTitleCss {
    font-size: 20px;
    color: #f85b02;
    font-weight: bold;
    margin-bottom: 20px;
    padding: 0 30px;
  }

  .phoneDivInputCss {
    width: 280px;
    margin-bottom: 20px;
  }

  .phoneInputCss {
    border: none;
    width: 267px;
    height: 35px;
    background: #f0f4ff;
    border-radius: 4px;
    padding-left: 12px;
  }

  .codeDivInputCss {
    width: 280px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
  }

  .codeInputCss {
    border: none;
    width: 160px;
    height: 35px;
    background: #f0f4ff;
    border-radius: 4px;
    padding-left: 12px;
  }

  .codeBtnCss {
    border: none;
    width: 90px;
    height: 35px;
    background: #ffa200;
    border-radius: 4px;
    font-size: 13px;
    color: #fff;
    padding: 0;
    margin: 0;
  }

  .submitDivBtnCss {
    width: 100%;
    margin: 25px 0;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .aLabel {
    width: 280px;
    height: 40px;
    border: none;
    color: #fff;
    font-weight: 500;
    font-size: 16px;
    background: linear-gradient(90deg, #f85700, #ff931e);
    box-shadow: 0px 3px 10px 0px rgba(255, 117, 7, 0.5);
    border-radius: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .submitBtnCss {
    width: 280px;
    height: 40px;
    border: none;
    color: #fff;
    font-weight: 500;
    font-size: 16px;
    background: linear-gradient(90deg, #f85700, #ff931e);
    box-shadow: 0px 3px 10px 0px rgba(255, 117, 7, 0.5);
    border-radius: 44px;
  }
</style>